import cx from 'classnames';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, InformationModal} from 'components';
import {AsyncRequestStatusName, Coordinates, ParticipantAsyncRequest} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.ASYNC_REQUEST.UPLOAD_SELFIE_VERIFICATION;

type Props = {
    open: boolean;
    asyncRequest: ParticipantAsyncRequest<Coordinates>;
    onClose: () => void;
};

export const UploadSelfieVerificationDialog: React.FC<Props> = ({open, asyncRequest, onClose}: Props) => {
    const {t} = useTranslation();
    const {success, failed} = useMemo(() => {
        const successStatus = asyncRequest?.status.name === AsyncRequestStatusName.Success;
        return {success: successStatus, failed: !successStatus};
    }, [asyncRequest]);

    return (
        <InformationModal
            open={open}
            maxWidth='xss'
            fullWidth
            onClose={onClose}
        >
            {asyncRequest &&
                <div className='tw-flex tw-flex-col tw-items-center'>
                    {success ?
                        <Icon name='check-circle' color='success' size='8xl' thickness='sm' /> :
                        <Icon name='x-circle' color='alert' size='8xl' thickness='sm' />}
                    <div className={cx('tw-mt-6 tw-ts-h5', {'tw-text-success': success, 'tw-text-alert': failed})}>
                        {t(success ? T_KEYS.SUCCESS_MSG : T_KEYS.FAILED_MSG)}
                    </div>
                </div>}
        </InformationModal>
    );
};
